<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1"><div class="section level2" id="prologue-1">
<p style="text-align: center; width:550px;"><img alt="" src="media/image10.jpeg" style="width:550px;"/></p>
<p style="text-align: right; width:500px;font-size: 20pt; font-family: calibri; padding-top:100px;">
<em>Chapter 1</em></p><br/>
<p style="width: 500px; font-size: 10pt; font-size: 40pt; font-family: calibri; text-align: right;">The North Sea</p>
<p style="width: 500px; font-size: 10pt; font-family: calibri; padding-top: 100px; text-align: right; ">View of the stallion approval in Groningen on 28th August, the city’s annual feast day</p>
<p style="width:500px;  font-size:10pt;font-family:calibri; text-align: right;"><em>Oil on canvas, Otto Erelman, 1920, City Hall, Groningen</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0014.vue?54172fb8